module.exports = __webpack_public_path__ + "img/pro-four.eaf49ae6.png";